import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "campervan"
const CampervanIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 8h2V6l-2-2H3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h1a3 3 0 0 0 6 0h5a3 3 0 0 0 6 0h2v-5l-3-4ZM7 18.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM9 12H3V9h6v3Zm5 3h-3V9h3v6Zm4 3.5a1.5 1.5 0 1 1 1.5-1.5 1.54 1.54 0 0 1-1.5 1.5ZM17 12V9.5h2.5l2 2.5H17Z" />
    </svg>
  )
}
export default CampervanIcon
